var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PPP-Fix",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regular-Copy-2",
    transform: "translate(-445.000000, -118.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(433.851852, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3703704,23.2 L12.9259259,23.2 L12.9259259,13.3 L25.3703704,13.3 M22.7037037,7 L22.7037037,8.8 L15.5925926,8.8 L15.5925926,7 L13.8148148,7 L13.8148148,8.8 L12.9259259,8.8 C11.9392593,8.8 11.1481481,9.601 11.1481481,10.6 L11.1481481,23.2 C11.1481481,24.1941125 11.9440864,25 12.9259259,25 L25.3703704,25 C26.3522099,25 27.1481481,24.1941125 27.1481481,23.2 L27.1481481,10.6 C27.1481481,9.601 26.3481481,8.8 25.3703704,8.8 L24.4814815,8.8 L24.4814815,7 M23.5925926,16.9 L19.1481481,16.9 L19.1481481,21.4 L23.5925926,21.4 L23.5925926,16.9 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar-black.8d0e5bcaf6efba3b4a0b7e53a1deac8f.svg";
export { ForwardRef as ReactComponent };